import React from 'react'
import {find} from 'lodash'

import {replaceExpression} from '../utils'
import PrintExplanationText from './PrintExplanationText'

export default class PrintTextQuestion extends React.Component {
  getValue(optionId) {
    const value = find(this.props.state, s => s.optionId === optionId)
    return value && value.stringValue
  }

  render() {
    const {data, answermap, collaborationresponse} = this.props
    const questionHasCountedCollaboration = collaborationresponse ? (Object.keys(collaborationresponse).length > 0) : false
    const tableStyle = {
      fontSize: 10 + 'px'
    }

    return (
      <div className="question-group type-text">
        <p style={{fontSize: '15px', lineHeight: '1.3em'}}>{replaceExpression(data.questionText, answermap)}</p>
        <div style={{fontSize: '11px', fontStyle: 'italic', lineHeight: '1.4em'}}
             dangerouslySetInnerHTML={{__html: replaceExpression(data.explanation, answermap)}}></div>

        {questionHasCountedCollaboration && <table style={tableStyle} width="100%">
          <tbody>
            <tr>
              <td width="55%"><span>Opmerkingen</span></td>
              <td width="45%"><span>&nbsp;</span></td>
            </tr>
            {data.options.map((option, i) => (
              <PrintExplanationText option={option}
                                    collaborationresponse={collaborationresponse}
                                    explanation={false}/>
            ))}
          </tbody>
        </table>}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PrintTextQuestion.js